// Pure helpers for the quarantined-household issue's decide flow (Baker
// 2026-07-13). hh-quarantined asks "Is X a real, distinct household?"
// but its recommended action used to dead-end at "needs the full review
// screen". The rail now offers the three resolutions directly:
//
//   keep-current — "It's a real household": clears is_quarantined
//     (quarantine_reason preserved as the paper trail); 60s undo
//     re-flags + reopens (existing restore-quarantine kind).
//   merge — opens the existing household merge picker (search for the
//     destination, review every field, then merge).
//   archive — the generic archive verb (soft, restorable; refused with
//     a plain-language reason if anything active is still attached).
//
// Root-safe (imports nothing) so it's unit-tested from tests/web/.

// Minimal structural subset of CleanupIssueSummary this module reads.
export interface QuarantineIssueLike {
  detectorSlug: string;
}

export function isQuarantineIssue(issue: QuarantineIssueLike): boolean {
  return issue.detectorSlug === "hh-quarantined";
}

export const QUARANTINE_KEEP_LABEL =
  "It's a real household — clear the flag";

export function quarantineKeepConsequence(): string {
  return "Confirms this is genuinely its own household and clears the migration's quarantine flag — it starts appearing in normal lists and views. The original quarantine reason is kept on the record as the paper trail. Audited; reversible for 60 seconds (undo re-flags it and reopens this item).";
}

export const QUARANTINE_ARCHIVE_LABEL =
  "Not a real household — archive it";

export function quarantineArchiveConsequence(): string {
  return "Archives the household — removed from every list and view, but the row and a version snapshot are kept, so it's fully restorable. If anything active is still attached (a policy, loan, open opportunity…), the archive is refused with a note saying what to relink first. Reversible for 60 seconds here, and any time after.";
}

export const QUARANTINE_MERGE_LABEL = "Merge into another household…";
